enum Size {
  small = 'small',
  middle = 'middle',
  large = 'large'
}

export default Size;
